
export const modes = {
    dorian: {
        notes: ['C4', 'D4', 'Eb4', 'F4', 'G4', 'A4', 'Bb4', 'C5'],
        name: 'Dorian',
    },
    phrygian: {
        notes: ['C4', 'Db4', 'Eb4', 'F4', 'G4', 'Ab4', 'Bb4', 'C5'],
        name: 'Phrygian',
    },
    lydian: {
        notes: ['C4', 'D4', 'E4', 'F#4', 'G4', 'A4', 'B4', 'C5'],
        name: 'Lydian',
    },
    mixolydian: {
        notes: ['C4', 'D4', 'E4', 'F4', 'G4', 'A4', 'Bb4', 'C5'],
        name: 'Mixolydian',
    },
    aeolian: {
        notes: ['C4', 'D4', 'Eb4', 'F4', 'G4', 'Ab4', 'Bb4', 'C5'],
        name: 'Aeolian',
    },
    locrian: {
        notes: ['C4', 'Db4', 'Eb4', 'F4', 'Gb4', 'Ab4', 'Bb4', 'C5'],
        name: 'Locrian',
    },
    major: {
        notes: ['C4', 'D4', 'E4', 'F4', 'G4', 'A4', 'B4', 'C5'],
        name: 'Major',
    },
    minor: {
        notes: ['C4', 'D4', 'Eb4', 'F4', 'G4', 'Ab4', 'Bb4', 'C5'],
        name: 'Minor',
    },
    chromatic: {
        notes: ['C4', 'C#4', 'D4', 'Eb4', 'E4', 'F4', 'F#4', 'G4', 'Ab4', 'A4', 'Bb4', 'B4', 'C5'],
        name: 'Chromatic',
    },
    wholeTone: {
        notes: ['C4', 'D4', 'E4', 'F#4', 'G#4', 'Bb4', 'C5'],
        name: 'Whole Tone',
    },
    pentatonicMajor: {
        notes: ['C4', 'D4', 'E4', 'G4', 'A4', 'C5'],
        name: 'Pentatonic Major',
    },
    pentatonicMinor: {
        notes: ['C4', 'Eb4', 'F4', 'G4', 'Bb4', 'C5'],
        name: 'Pentatonic Minor',
    },
    blues: {
        notes: ['C4', 'Eb4', 'F4', 'F#4', 'G4', 'Bb4', 'C5'],
        name: 'Blues',
    },
    spanish: {
        notes: ['C4', 'Db4', 'E4', 'F4', 'G4', 'Ab4', 'B4', 'C5'],
        name: 'Spanish',
    },
    arabic: {
        notes: ['C4', 'Db4', 'E4', 'F4', 'G4', 'Ab4', 'B4', 'C5'],
        name: 'Arabic',
    }
}

